
import React from "react";
import { GroupWithProducts } from "./GroupUsageCard";
import GroupUsageCard from "./GroupUsageCard";
import AddGroupCard from "./AddGroupCard";

export interface GroupsGridProps {
  groups: GroupWithProducts[];
  onTrackUsage: (groupId: string) => void;
  onAddGroup: () => void;
}

const GroupsGrid: React.FC<GroupsGridProps> = ({ 
  groups, 
  onTrackUsage, 
  onAddGroup 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {groups.map(group => (
        <GroupUsageCard
          key={group.id}
          group={group}
          onTrackUsage={() => onTrackUsage(group.id)}
        />
      ))}
      
      <AddGroupCard onAddGroup={onAddGroup} />
    </div>
  );
};

export default GroupsGrid;
